import { giphyLightCharcoal } from '@giphy/colors'
import { useContext } from 'react'
import styled from 'styled-components'
import { CopilotContext } from '../context'
import { Preset } from './style'

const NoPresets = styled.div`
    align-items: center;
    display: flex;
    color: ${giphyLightCharcoal};
    min-height: 50px;
    justify-content: center;
`

type Props = {
    className?: string
}

const CopilotDropdownPresets = ({ className }: Props) => {
    const { activePresetId, presets } = useContext(CopilotContext)

    if (!presets.length) {
        return (
            <div className={className}>
                <NoPresets>Your presets will appear here</NoPresets>
            </div>
        )
    }

    return (
        <div className={className}>
            {presets.map((preset) => (
                <Preset
                    $active={preset.id === activePresetId}
                    key={`copilot-dropdown-item-${preset.id}`}
                    preset={preset}
                    size="small"
                />
            ))}
        </div>
    )
}

export default CopilotDropdownPresets
